import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { FilterGroup } from '@tv3/services/utils/filters.service'

@Component({
  selector: 'app-cancel-filters',
  templateUrl: './cancel-filters.component.html',
  styleUrls: ['./cancel-filters.component.scss'],
})
export class CancelFiltersComponent {
  @Input() filterGroup: FilterGroup
  @Input() filterControl: FormGroup

  @Output() clearFilters = new EventEmitter()

  onClearFilters() {
    if (this.filterControl) {
      this.filterControl.reset()
    }
    this.clearFilters.emit(true)
  }
}
